// TODO: napraviti lookup za country code, povezati sa drzavama, nakon toga izbrisati ovaj fajl
export const CountryCode = [
    {
        "CountryName": "Afghanistan",
        "CountryCode": "+93",
        "CountryNameAcronym": "AF"
    },
    {
        "CountryName": "Aland Islands",
        "CountryCode": "+358",
        "CountryNameAcronym": "AX"
    },
    {
        "CountryName": "Albania",
        "CountryCode": "+355",
        "CountryNameAcronym": "AL"
    },
    {
        "CountryName": "Algeria",
        "CountryCode": "+213",
        "CountryNameAcronym": "DZ"
    },
    {
        "CountryName": "AmericanSamoa",
        "CountryCode": "+1684",
        "CountryNameAcronym": "AS"
    },
    {
        "CountryName": "Andorra",
        "CountryCode": "+376",
        "CountryNameAcronym": "AD"
    },
    {
        "CountryName": "Angola",
        "CountryCode": "+244",
        "CountryNameAcronym": "AO"
    },
    {
        "CountryName": "Anguilla",
        "CountryCode": "+1264",
        "CountryNameAcronym": "AI"
    },
    {
        "CountryName": "Antarctica",
        "CountryCode": "+672",
        "CountryNameAcronym": "AQ"
    },
    {
        "CountryName": "Antigua and Barbuda",
        "CountryCode": "+1268",
        "CountryNameAcronym": "AG"
    },
    {
        "CountryName": "Argentina",
        "CountryCode": "+54",
        "CountryNameAcronym": "AR"
    },
    {
        "CountryName": "Armenia",
        "CountryCode": "+374",
        "CountryNameAcronym": "AM"
    },
    {
        "CountryName": "Aruba",
        "CountryCode": "+297",
        "CountryNameAcronym": "AW"
    },
    {
        "CountryName": "Australia",
        "CountryCode": "+61",
        "CountryNameAcronym": "AU"
    },
    {
        "CountryName": "Austria",
        "CountryCode": "+43",
        "CountryNameAcronym": "AT"
    },
    {
        "CountryName": "Azerbaijan",
        "CountryCode": "+994",
        "CountryNameAcronym": "AZ"
    },
    {
        "CountryName": "Bahamas",
        "CountryCode": "+1242",
        "CountryNameAcronym": "BS"
    },
    {
        "CountryName": "Bahrain",
        "CountryCode": "+973",
        "CountryNameAcronym": "BH"
    },
    {
        "CountryName": "Bangladesh",
        "CountryCode": "+880",
        "CountryNameAcronym": "BD"
    },
    {
        "CountryName": "Barbados",
        "CountryCode": "+1246",
        "CountryNameAcronym": "BB"
    },
    {
        "CountryName": "Belarus",
        "CountryCode": "+375",
        "CountryNameAcronym": "BY"
    },
    {
        "CountryName": "Belgium",
        "CountryCode": "+32",
        "CountryNameAcronym": "BE"
    },
    {
        "CountryName": "Belize",
        "CountryCode": "+501",
        "CountryNameAcronym": "BZ"
    },
    {
        "CountryName": "Benin",
        "CountryCode": "+229",
        "CountryNameAcronym": "BJ"
    },
    {
        "CountryName": "Bermuda",
        "CountryCode": "+1441",
        "CountryNameAcronym": "BM"
    },
    {
        "CountryName": "Bhutan",
        "CountryCode": "+975",
        "CountryNameAcronym": "BT"
    },
    {
        "CountryName": "Bolivia, Plurinational State of",
        "CountryCode": "+591",
        "CountryNameAcronym": "BO"
    },
    {
        "CountryName": "Bosnia and Herzegovina",
        "CountryCode": "+387",
        "CountryNameAcronym": "BA"
    },
    {
        "CountryName": "Botswana",
        "CountryCode": "+267",
        "CountryNameAcronym": "BW"
    },
    {
        "CountryName": "Brazil",
        "CountryCode": "+55",
        "CountryNameAcronym": "BR"
    },
    {
        "CountryName": "British Indian Ocean Territory",
        "CountryCode": "+246",
        "CountryNameAcronym": "IO"
    },
    {
        "CountryName": "Brunei Darussalam",
        "CountryCode": "+673",
        "CountryNameAcronym": "BN"
    },
    {
        "CountryName": "Bulgaria",
        "CountryCode": "+359",
        "CountryNameAcronym": "BG"
    },
    {
        "CountryName": "Burkina Faso",
        "CountryCode": "+226",
        "CountryNameAcronym": "BF"
    },
    {
        "CountryName": "Burundi",
        "CountryCode": "+257",
        "CountryNameAcronym": "BI"
    },
    {
        "CountryName": "Cambodia",
        "CountryCode": "+855",
        "CountryNameAcronym": "KH"
    },
    {
        "CountryName": "Cameroon",
        "CountryCode": "+237",
        "CountryNameAcronym": "CM"
    },
    {
        "CountryName": "Canada",
        "CountryCode": "+1",
        "CountryNameAcronym": "CA"
    },
    {
        "CountryName": "Cape Verde",
        "CountryCode": "+238",
        "CountryNameAcronym": "CV"
    },
    {
        "CountryName": "Cayman Islands",
        "CountryCode": "+345",
        "CountryNameAcronym": "KY"
    },
    {
        "CountryName": "Central African Republic",
        "CountryCode": "+236",
        "CountryNameAcronym": "CF"
    },
    {
        "CountryName": "Chad",
        "CountryCode": "+235",
        "CountryNameAcronym": "TD"
    },
    {
        "CountryName": "Chile",
        "CountryCode": "+56",
        "CountryNameAcronym": "CL"
    },
    {
        "CountryName": "China",
        "CountryCode": "+86",
        "CountryNameAcronym": "CN"
    },
    {
        "CountryName": "Christmas Island",
        "CountryCode": "+61",
        "CountryNameAcronym": "CX"
    },
    {
        "CountryName": "Cocos (Keeling) Islands",
        "CountryCode": "+61",
        "CountryNameAcronym": "CC"
    },
    {
        "CountryName": "Colombia",
        "CountryCode": "+57",
        "CountryNameAcronym": "CO"
    },
    {
        "CountryName": "Comoros",
        "CountryCode": "+269",
        "CountryNameAcronym": "KM"
    },
    {
        "CountryName": "Congo",
        "CountryCode": "+242",
        "CountryNameAcronym": "CG"
    },
    {
        "CountryName": "Congo, The Democratic Republic of the Congo",
        "CountryCode": "+243",
        "CountryNameAcronym": "CD"
    },
    {
        "CountryName": "Cook Islands",
        "CountryCode": "+682",
        "CountryNameAcronym": "CK"
    },
    {
        "CountryName": "Costa Rica",
        "CountryCode": "+506",
        "CountryNameAcronym": "CR"
    },
    {
        "CountryName": "Cote d'Ivoire",
        "CountryCode": "+225",
        "CountryNameAcronym": "CI"
    },
    {
        "CountryName": "Croatia",
        "CountryCode": "+385",
        "CountryNameAcronym": "HR"
    },
    {
        "CountryName": "Cuba",
        "CountryCode": "+53",
        "CountryNameAcronym": "CU"
    },
    {
        "CountryName": "Cyprus",
        "CountryCode": "+357",
        "CountryNameAcronym": "CY"
    },
    {
        "CountryName": "Czech Republic",
        "CountryCode": "+420",
        "CountryNameAcronym": "CZ"
    },
    {
        "CountryName": "Denmark",
        "CountryCode": "+45",
        "CountryNameAcronym": "DK"
    },
    {
        "CountryName": "Djibouti",
        "CountryCode": "+253",
        "CountryNameAcronym": "DJ"
    },
    {
        "CountryName": "Dominica",
        "CountryCode": "+1767",
        "CountryNameAcronym": "DM"
    },
    {
        "CountryName": "Dominican Republic",
        "CountryCode": "+1849",
        "CountryNameAcronym": "DO"
    },
    {
        "CountryName": "Ecuador",
        "CountryCode": "+593",
        "CountryNameAcronym": "EC"
    },
    {
        "CountryName": "Egypt",
        "CountryCode": "+20",
        "CountryNameAcronym": "EG"
    },
    {
        "CountryName": "El Salvador",
        "CountryCode": "+503",
        "CountryNameAcronym": "SV"
    },
    {
        "CountryName": "Equatorial Guinea",
        "CountryCode": "+240",
        "CountryNameAcronym": "GQ"
    },
    {
        "CountryName": "Eritrea",
        "CountryCode": "+291",
        "CountryNameAcronym": "ER"
    },
    {
        "CountryName": "Estonia",
        "CountryCode": "+372",
        "CountryNameAcronym": "EE"
    },
    {
        "CountryName": "Ethiopia",
        "CountryCode": "+251",
        "CountryNameAcronym": "ET"
    },
    {
        "CountryName": "Falkland Islands (Malvinas)",
        "CountryCode": "+500",
        "CountryNameAcronym": "FK"
    },
    {
        "CountryName": "Faroe Islands",
        "CountryCode": "+298",
        "CountryNameAcronym": "FO"
    },
    {
        "CountryName": "Fiji",
        "CountryCode": "+679",
        "CountryNameAcronym": "FJ"
    },
    {
        "CountryName": "Finland",
        "CountryCode": "+358",
        "CountryNameAcronym": "FI"
    },
    {
        "CountryName": "France",
        "CountryCode": "+33",
        "CountryNameAcronym": "FR"
    },
    {
        "CountryName": "French Guiana",
        "CountryCode": "+594",
        "CountryNameAcronym": "GF"
    },
    {
        "CountryName": "French Polynesia",
        "CountryCode": "+689",
        "CountryNameAcronym": "PF"
    },
    {
        "CountryName": "Gabon",
        "CountryCode": "+241",
        "CountryNameAcronym": "GA"
    },
    {
        "CountryName": "Gambia",
        "CountryCode": "+220",
        "CountryNameAcronym": "GM"
    },
    {
        "CountryName": "Georgia",
        "CountryCode": "+995",
        "CountryNameAcronym": "GE"
    },
    {
        "CountryName": "Germany",
        "CountryCode": "+49",
        "CountryNameAcronym": "DE"
    },
    {
        "CountryName": "Ghana",
        "CountryCode": "+233",
        "CountryNameAcronym": "GH"
    },
    {
        "CountryName": "Gibraltar",
        "CountryCode": "+350",
        "CountryNameAcronym": "GI"
    },
    {
        "CountryName": "Greece",
        "CountryCode": "+30",
        "CountryNameAcronym": "GR"
    },
    {
        "CountryName": "Greenland",
        "CountryCode": "+299",
        "CountryNameAcronym": "GL"
    },
    {
        "CountryName": "Grenada",
        "CountryCode": "+1473",
        "CountryNameAcronym": "GD"
    },
    {
        "CountryName": "Guadeloupe",
        "CountryCode": "+590",
        "CountryNameAcronym": "GP"
    },
    {
        "CountryName": "Guam",
        "CountryCode": "+1671",
        "CountryNameAcronym": "GU"
    },
    {
        "CountryName": "Guatemala",
        "CountryCode": "+502",
        "CountryNameAcronym": "GT"
    },
    {
        "CountryName": "Guernsey",
        "CountryCode": "+44",
        "CountryNameAcronym": "GG"
    },
    {
        "CountryName": "Guinea",
        "CountryCode": "+224",
        "CountryNameAcronym": "GN"
    },
    {
        "CountryName": "Guinea-Bissau",
        "CountryCode": "+245",
        "CountryNameAcronym": "GW"
    },
    {
        "CountryName": "Guyana",
        "CountryCode": "+595",
        "CountryNameAcronym": "GY"
    },
    {
        "CountryName": "Haiti",
        "CountryCode": "+509",
        "CountryNameAcronym": "HT"
    },
    {
        "CountryName": "Holy See (Vatican City State)",
        "CountryCode": "+379",
        "CountryNameAcronym": "VA"
    },
    {
        "CountryName": "Honduras",
        "CountryCode": "+504",
        "CountryNameAcronym": "HN"
    },
    {
        "CountryName": "Hong Kong",
        "CountryCode": "+852",
        "CountryNameAcronym": "HK"
    },
    {
        "CountryName": "Hungary",
        "CountryCode": "+36",
        "CountryNameAcronym": "HU"
    },
    {
        "CountryName": "Iceland",
        "CountryCode": "+354",
        "CountryNameAcronym": "IS"
    },
    {
        "CountryName": "India",
        "CountryCode": "+91",
        "CountryNameAcronym": "IN"
    },
    {
        "CountryName": "Indonesia",
        "CountryCode": "+62",
        "CountryNameAcronym": "ID"
    },
    {
        "CountryName": "Iran, Islamic Republic of Persian Gulf",
        "CountryCode": "+98",
        "CountryNameAcronym": "IR"
    },
    {
        "CountryName": "Iraq",
        "CountryCode": "+964",
        "CountryNameAcronym": "IQ"
    },
    {
        "CountryName": "Ireland",
        "CountryCode": "+353",
        "CountryNameAcronym": "IE"
    },
    {
        "CountryName": "Isle of Man",
        "CountryCode": "+44",
        "CountryNameAcronym": "IM"
    },
    {
        "CountryName": "Israel",
        "CountryCode": "+972",
        "CountryNameAcronym": "IL"
    },
    {
        "CountryName": "Italy",
        "CountryCode": "+39",
        "CountryNameAcronym": "IT"
    },
    {
        "CountryName": "Jamaica",
        "CountryCode": "+1876",
        "CountryNameAcronym": "JM"
    },
    {
        "CountryName": "Japan",
        "CountryCode": "+81",
        "CountryNameAcronym": "JP"
    },
    {
        "CountryName": "Jersey",
        "CountryCode": "+44",
        "CountryNameAcronym": "JE"
    },
    {
        "CountryName": "Jordan",
        "CountryCode": "+962",
        "CountryNameAcronym": "JO"
    },
    {
        "CountryName": "Kazakhstan",
        "CountryCode": "+77",
        "CountryNameAcronym": "KZ"
    },
    {
        "CountryName": "Kenya",
        "CountryCode": "+254",
        "CountryNameAcronym": "KE"
    },
    {
        "CountryName": "Kiribati",
        "CountryCode": "+686",
        "CountryNameAcronym": "KI"
    },
    {
        "CountryName": "Korea, Democratic People's Republic of Korea",
        "CountryCode": "+850",
        "CountryNameAcronym": "KP"
    },
    {
        "CountryName": "Korea, Republic of South Korea",
        "CountryCode": "+82",
        "CountryNameAcronym": "KR"
    },
    {
        "CountryName": "Kuwait",
        "CountryCode": "+965",
        "CountryNameAcronym": "KW"
    },
    {
        "CountryName": "Kyrgyzstan",
        "CountryCode": "+996",
        "CountryNameAcronym": "KG"
    },
    {
        "CountryName": "Laos",
        "CountryCode": "+856",
        "CountryNameAcronym": "LA"
    },
    {
        "CountryName": "Latvia",
        "CountryCode": "+371",
        "CountryNameAcronym": "LV"
    },
    {
        "CountryName": "Lebanon",
        "CountryCode": "+961",
        "CountryNameAcronym": "LB"
    },
    {
        "CountryName": "Lesotho",
        "CountryCode": "+266",
        "CountryNameAcronym": "LS"
    },
    {
        "CountryName": "Liberia",
        "CountryCode": "+231",
        "CountryNameAcronym": "LR"
    },
    {
        "CountryName": "Libyan Arab Jamahiriya",
        "CountryCode": "+218",
        "CountryNameAcronym": "LY"
    },
    {
        "CountryName": "Liechtenstein",
        "CountryCode": "+423",
        "CountryNameAcronym": "LI"
    },
    {
        "CountryName": "Lithuania",
        "CountryCode": "+370",
        "CountryNameAcronym": "LT"
    },
    {
        "CountryName": "Luxembourg",
        "CountryCode": "+352",
        "CountryNameAcronym": "LU"
    },
    {
        "CountryName": "Macao",
        "CountryCode": "+853",
        "CountryNameAcronym": "MO"
    },
    {
        "CountryName": "Macedonia",
        "CountryCode": "+389",
        "CountryNameAcronym": "MK"
    },
    {
        "CountryName": "Madagascar",
        "CountryCode": "+261",
        "CountryNameAcronym": "MG"
    },
    {
        "CountryName": "Malawi",
        "CountryCode": "+265",
        "CountryNameAcronym": "MW"
    },
    {
        "CountryName": "Malaysia",
        "CountryCode": "+60",
        "CountryNameAcronym": "MY"
    },
    {
        "CountryName": "Maldives",
        "CountryCode": "+960",
        "CountryNameAcronym": "MV"
    },
    {
        "CountryName": "Mali",
        "CountryCode": "+223",
        "CountryNameAcronym": "ML"
    },
    {
        "CountryName": "Malta",
        "CountryCode": "+356",
        "CountryNameAcronym": "MT"
    },
    {
        "CountryName": "Marshall Islands",
        "CountryCode": "+692",
        "CountryNameAcronym": "MH"
    },
    {
        "CountryName": "Martinique",
        "CountryCode": "+596",
        "CountryNameAcronym": "MQ"
    },
    {
        "CountryName": "Mauritania",
        "CountryCode": "+222",
        "CountryNameAcronym": "MR"
    },
    {
        "CountryName": "Mauritius",
        "CountryCode": "+230",
        "CountryNameAcronym": "MU"
    },
    {
        "CountryName": "Mayotte",
        "CountryCode": "+262",
        "CountryNameAcronym": "YT"
    },
    {
        "CountryName": "Mexico",
        "CountryCode": "+52",
        "CountryNameAcronym": "MX"
    },
    {
        "CountryName": "Micronesia, Federated States of Micronesia",
        "CountryCode": "+691",
        "CountryNameAcronym": "FM"
    },
    {
        "CountryName": "Moldova",
        "CountryCode": "+373",
        "CountryNameAcronym": "MD"
    },
    {
        "CountryName": "Monaco",
        "CountryCode": "+377",
        "CountryNameAcronym": "MC"
    },
    {
        "CountryName": "Mongolia",
        "CountryCode": "+976",
        "CountryNameAcronym": "MN"
    },
    {
        "CountryName": "Montenegro",
        "CountryCode": "+382",
        "CountryNameAcronym": "ME"
    },
    {
        "CountryName": "Montserrat",
        "CountryCode": "+1664",
        "CountryNameAcronym": "MS"
    },
    {
        "CountryName": "Morocco",
        "CountryCode": "+212",
        "CountryNameAcronym": "MA"
    },
    {
        "CountryName": "Mozambique",
        "CountryCode": "+258",
        "CountryNameAcronym": "MZ"
    },
    {
        "CountryName": "Myanmar",
        "CountryCode": "+95",
        "CountryNameAcronym": "MM"
    },
    {
        "CountryName": "Namibia",
        "CountryCode": "+264",
        "CountryNameAcronym": "NA"
    },
    {
        "CountryName": "Nauru",
        "CountryCode": "+674",
        "CountryNameAcronym": "NR"
    },
    {
        "CountryName": "Nepal",
        "CountryCode": "+977",
        "CountryNameAcronym": "NP"
    },
    {
        "CountryName": "Netherlands",
        "CountryCode": "+31",
        "CountryNameAcronym": "NL"
    },
    {
        "CountryName": "Netherlands Antilles",
        "CountryCode": "+599",
        "CountryNameAcronym": "AN"
    },
    {
        "CountryName": "New Caledonia",
        "CountryCode": "+687",
        "CountryNameAcronym": "NC"
    },
    {
        "CountryName": "New Zealand",
        "CountryCode": "+64",
        "CountryNameAcronym": "NZ"
    },
    {
        "CountryName": "Nicaragua",
        "CountryCode": "+505",
        "CountryNameAcronym": "NI"
    },
    {
        "CountryName": "Niger",
        "CountryCode": "+227",
        "CountryNameAcronym": "NE"
    },
    {
        "CountryName": "Nigeria",
        "CountryCode": "+234",
        "CountryNameAcronym": "NG"
    },
    {
        "CountryName": "Niue",
        "CountryCode": "+683",
        "CountryNameAcronym": "NU"
    },
    {
        "CountryName": "Norfolk Island",
        "CountryCode": "+672",
        "CountryNameAcronym": "NF"
    },
    {
        "CountryName": "Northern Mariana Islands",
        "CountryCode": "+1670",
        "CountryNameAcronym": "MP"
    },
    {
        "CountryName": "Norway",
        "CountryCode": "+47",
        "CountryNameAcronym": "NO"
    },
    {
        "CountryName": "Oman",
        "CountryCode": "+968",
        "CountryNameAcronym": "OM"
    },
    {
        "CountryName": "Pakistan",
        "CountryCode": "+92",
        "CountryNameAcronym": "PK"
    },
    {
        "CountryName": "Palau",
        "CountryCode": "+680",
        "CountryNameAcronym": "PW"
    },
    {
        "CountryName": "Palestinian Territory, Occupied",
        "CountryCode": "+970",
        "CountryNameAcronym": "PS"
    },
    {
        "CountryName": "Panama",
        "CountryCode": "+507",
        "CountryNameAcronym": "PA"
    },
    {
        "CountryName": "Papua New Guinea",
        "CountryCode": "+675",
        "CountryNameAcronym": "PG"
    },
    {
        "CountryName": "Paraguay",
        "CountryCode": "+595",
        "CountryNameAcronym": "PY"
    },
    {
        "CountryName": "Peru",
        "CountryCode": "+51",
        "CountryNameAcronym": "PE"
    },
    {
        "CountryName": "Philippines",
        "CountryCode": "+63",
        "CountryNameAcronym": "PH"
    },
    {
        "CountryName": "Pitcairn",
        "CountryCode": "+872",
        "CountryNameAcronym": "PN"
    },
    {
        "CountryName": "Poland",
        "CountryCode": "+48",
        "CountryNameAcronym": "PL"
    },
    {
        "CountryName": "Portugal",
        "CountryCode": "+351",
        "CountryNameAcronym": "PT"
    },
    {
        "CountryName": "Puerto Rico",
        "CountryCode": "+1939",
        "CountryNameAcronym": "PR"
    },
    {
        "CountryName": "Qatar",
        "CountryCode": "+974",
        "CountryNameAcronym": "QA"
    },
    {
        "CountryName": "Romania",
        "CountryCode": "+40",
        "CountryNameAcronym": "RO"
    },
    {
        "CountryName": "Russia",
        "CountryCode": "+7",
        "CountryNameAcronym": "RU"
    },
    {
        "CountryName": "Rwanda",
        "CountryCode": "+250",
        "CountryNameAcronym": "RW"
    },
    {
        "CountryName": "Reunion",
        "CountryCode": "+262",
        "CountryNameAcronym": "RE"
    },
    {
        "CountryName": "Saint Barthelemy",
        "CountryCode": "+590",
        "CountryNameAcronym": "BL"
    },
    {
        "CountryName": "Saint Helena, Ascension and Tristan Da Cunha",
        "CountryCode": "+290",
        "CountryNameAcronym": "SH"
    },
    {
        "CountryName": "Saint Kitts and Nevis",
        "CountryCode": "+1869",
        "CountryNameAcronym": "KN"
    },
    {
        "CountryName": "Saint Lucia",
        "CountryCode": "+1758",
        "CountryNameAcronym": "LC"
    },
    {
        "CountryName": "Saint Martin",
        "CountryCode": "+590",
        "CountryNameAcronym": "MF"
    },
    {
        "CountryName": "Saint Pierre and Miquelon",
        "CountryCode": "+508",
        "CountryNameAcronym": "PM"
    },
    {
        "CountryName": "Saint Vincent and the Grenadines",
        "CountryCode": "+1784",
        "CountryNameAcronym": "VC"
    },
    {
        "CountryName": "Samoa",
        "CountryCode": "+685",
        "CountryNameAcronym": "WS"
    },
    {
        "CountryName": "San Marino",
        "CountryCode": "+378",
        "CountryNameAcronym": "SM"
    },
    {
        "CountryName": "Sao Tome and Principe",
        "CountryCode": "+239",
        "CountryNameAcronym": "ST"
    },
    {
        "CountryName": "Saudi Arabia",
        "CountryCode": "+966",
        "CountryNameAcronym": "SA"
    },
    {
        "CountryName": "Senegal",
        "CountryCode": "+221",
        "CountryNameAcronym": "SN"
    },
    {
        "CountryName": "Serbia",
        "CountryCode": "+381",
        "CountryNameAcronym": "RS"
    },
    {
        "CountryName": "Seychelles",
        "CountryCode": "+248",
        "CountryNameAcronym": "SC"
    },
    {
        "CountryName": "Sierra Leone",
        "CountryCode": "+232",
        "CountryNameAcronym": "SL"
    },
    {
        "CountryName": "Singapore",
        "CountryCode": "+65",
        "CountryNameAcronym": "SG"
    },
    {
        "CountryName": "Slovakia",
        "CountryCode": "+421",
        "CountryNameAcronym": "SK"
    },
    {
        "CountryName": "Slovenia",
        "CountryCode": "+386",
        "CountryNameAcronym": "SI"
    },
    {
        "CountryName": "Solomon Islands",
        "CountryCode": "+677",
        "CountryNameAcronym": "SB"
    },
    {
        "CountryName": "Somalia",
        "CountryCode": "+252",
        "CountryNameAcronym": "SO"
    },
    {
        "CountryName": "South Africa",
        "CountryCode": "+27",
        "CountryNameAcronym": "ZA"
    },
    {
        "CountryName": "South Sudan",
        "CountryCode": "+211",
        "CountryNameAcronym": "SS"
    },
    {
        "CountryName": "South Georgia and the South Sandwich Islands",
        "CountryCode": "+500",
        "CountryNameAcronym": "GS"
    },
    {
        "CountryName": "Spain",
        "CountryCode": "+34",
        "CountryNameAcronym": "ES"
    },
    {
        "CountryName": "Sri Lanka",
        "CountryCode": "+94",
        "CountryNameAcronym": "LK"
    },
    {
        "CountryName": "Sudan",
        "CountryCode": "+249",
        "CountryNameAcronym": "SD"
    },
    {
        "CountryName": "Suriname",
        "CountryCode": "+597",
        "CountryNameAcronym": "SR"
    },
    {
        "CountryName": "Svalbard and Jan Mayen",
        "CountryCode": "+47",
        "CountryNameAcronym": "SJ"
    },
    {
        "CountryName": "Swaziland",
        "CountryCode": "+268",
        "CountryNameAcronym": "SZ"
    },
    {
        "CountryName": "Sweden",
        "CountryCode": "+46",
        "CountryNameAcronym": "SE"
    },
    {
        "CountryName": "Switzerland",
        "CountryCode": "+41",
        "CountryNameAcronym": "CH"
    },
    {
        "CountryName": "Syrian Arab Republic",
        "CountryCode": "+963",
        "CountryNameAcronym": "SY"
    },
    {
        "CountryName": "Taiwan",
        "CountryCode": "+886",
        "CountryNameAcronym": "TW"
    },
    {
        "CountryName": "Tajikistan",
        "CountryCode": "+992",
        "CountryNameAcronym": "TJ"
    },
    {
        "CountryName": "Tanzania, United Republic of Tanzania",
        "CountryCode": "+255",
        "CountryNameAcronym": "TZ"
    },
    {
        "CountryName": "Thailand",
        "CountryCode": "+66",
        "CountryNameAcronym": "TH"
    },
    {
        "CountryName": "Timor-Leste",
        "CountryCode": "+670",
        "CountryNameAcronym": "TL"
    },
    {
        "CountryName": "Togo",
        "CountryCode": "+228",
        "CountryNameAcronym": "TG"
    },
    {
        "CountryName": "Tokelau",
        "CountryCode": "+690",
        "CountryNameAcronym": "TK"
    },
    {
        "CountryName": "Tonga",
        "CountryCode": "+676",
        "CountryNameAcronym": "TO"
    },
    {
        "CountryName": "Trinidad and Tobago",
        "CountryCode": "+1868",
        "CountryNameAcronym": "TT"
    },
    {
        "CountryName": "Tunisia",
        "CountryCode": "+216",
        "CountryNameAcronym": "TN"
    },
    {
        "CountryName": "Turkey",
        "CountryCode": "+90",
        "CountryNameAcronym": "TR"
    },
    {
        "CountryName": "Turkmenistan",
        "CountryCode": "+993",
        "CountryNameAcronym": "TM"
    },
    {
        "CountryName": "Turks and Caicos Islands",
        "CountryCode": "+1649",
        "CountryNameAcronym": "TC"
    },
    {
        "CountryName": "Tuvalu",
        "CountryCode": "+688",
        "CountryNameAcronym": "TV"
    },
    {
        "CountryName": "Uganda",
        "CountryCode": "+256",
        "CountryNameAcronym": "UG"
    },
    {
        "CountryName": "Ukraine",
        "CountryCode": "+380",
        "CountryNameAcronym": "UA"
    },
    {
        "CountryName": "United Arab Emirates",
        "CountryCode": "+971",
        "CountryNameAcronym": "AE"
    },
    {
        "CountryName": "United Kingdom",
        "CountryCode": "+44",
        "CountryNameAcronym": "GB"
    },
    {
        "CountryName": "United States",
        "CountryCode": "+1",
        "CountryNameAcronym": "US"
    },
    {
        "CountryName": "Uruguay",
        "CountryCode": "+598",
        "CountryNameAcronym": "UY"
    },
    {
        "CountryName": "Uzbekistan",
        "CountryCode": "+998",
        "CountryNameAcronym": "UZ"
    },
    {
        "CountryName": "Vanuatu",
        "CountryCode": "+678",
        "CountryNameAcronym": "VU"
    },
    {
        "CountryName": "Venezuela, Bolivarian Republic of Venezuela",
        "CountryCode": "+58",
        "CountryNameAcronym": "VE"
    },
    {
        "CountryName": "Vietnam",
        "CountryCode": "+84",
        "CountryNameAcronym": "VN"
    },
    {
        "CountryName": "Virgin Islands, British",
        "CountryCode": "+1284",
        "CountryNameAcronym": "VG"
    },
    {
        "CountryName": "Virgin Islands, U.S.",
        "CountryCode": "+1340",
        "CountryNameAcronym": "VI"
    },
    {
        "CountryName": "Wallis and Futuna",
        "CountryCode": "+681",
        "CountryNameAcronym": "WF"
    },
    {
        "CountryName": "Yemen",
        "CountryCode": "+967",
        "CountryNameAcronym": "YE"
    },
    {
        "CountryName": "Zambia",
        "CountryCode": "+260",
        "CountryNameAcronym": "ZM"
    },
    {
        "CountryName": "Zimbabwe",
        "CountryCode": "+263",
        "CountryNameAcronym": "ZW"
    }
]

export const getCountryCodes = () => {
    return CountryCode.reduce((memo, it) => {
        memo[it["CountryCode"]] = `${it["CountryCode"]} ${it["CountryName"]} (${it["CountryNameAcronym"]})`
        return memo
    }, {})
}


export const DEFAULT_STATE = {
    "CountryID": 1,
    "CountryName": "USA",
    "ArchivedDate": null,
    "Abbreviation": "US",
    "CountryCode": "+1",
    "Country": "USA"
}